import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

/** Stock adjustments: the list (views by kind), the editor and each document. */
export const Route = createFileRoute('/_app/stock-adjustments')({
  staticData: { crumb: 'stockAdjustments' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  component: Outlet,
})
